<template>
<div class="ta-condition-report-wrapper">
  <h5
    class="ta-condition-report-title"
    v-if="showTitle"
  >
    {{ report.title }}
  </h5>
  <div
    class="ta-condition-report-body"
    v-html="report.body"
  />
  <ConditionReportImages
    v-if="report.images && report.images.length"
    :report-images="report.images"
  />
</div>
</template>

<script>
import {mapState} from "vuex";
import ConditionReportImages from "@/components/condition-report/ConditionReportImages.vue";

export default {
  name: "ConditionReport",
  components: {
    ConditionReportImages,
  },
  props: {
    report: Object,
    showTitle: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapState({
      lot: state => state.lotObject.data
    }),
  },
  methods: {}
}
</script>
